import { getSectionNameFromClassNameModelUtil } from 'models/utils/get-section-name'
import getDomainMapKeyFromPathReduxUtil from 'modules/redux/utils/get-domain-map-key-from-path'
import { getDomainPathReduxUtil } from 'modules/redux/utils/legacy/get-domain-path'
import { getObjectUtil } from 'packages/src'

/**
 * Gets the DomainList, using the given `instance`'s
 * Section and DomainMapValue as key.
 * @param  {string} path
 * @param  {Instance} instance
 * @returns {string}
 */
function getSectionDomainMapValueListPathReduxUtil (path, instance) {
  const section = getSectionNameFromClassNameModelUtil(instance.className)
  const domainPath = getDomainPathReduxUtil(instance.className)
  const domainMapKey = getDomainMapKeyFromPathReduxUtil(domainPath)
  const domainMapValue = getObjectUtil(instance, `data.${domainMapKey}`)
  return `${path}.${section}.${domainMapValue}`
}

export {
  getSectionDomainMapValueListPathReduxUtil
}
